var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import { compose, graphql, GrayText, PageLayout, Separator, Spinner } from "@atlassiansox/microscopekit";
import ServiceNotificationQuery from "../graphql/service-notifications.query.graphql";
import { NotificationDetailView } from "../components/NotificationDetailView";
import { NotificationEditForm } from "../components/FormView/ServiceNotificationEditForm";
import { NotificationCreateForm } from "../components/FormView/ServiceNotificationCreateForm";
import Breadcrumbs, { BreadcrumbsItem } from "@atlaskit/breadcrumbs";
import SectionMessage from "@atlaskit/section-message";
import LinkIcon from "@atlaskit/icon/glyph/link";
var WargameNotificationComponent = function (props) {
    var serviceId = props.id;
    var _a = __read(useState(false), 2), isEditMode = _a[0], setIsEditMode = _a[1];
    var _b = __read(useState(props.serviceNotificationsData.serviceNotificationsForByService), 2), serviceNotification = _b[0], setServiceNotification = _b[1];
    useEffect(function () {
        setServiceNotification(props.serviceNotificationsData.serviceNotificationsForByService);
    }, [
        props.serviceNotificationsData.serviceNotificationsForByService,
        setServiceNotification
    ]);
    return props.serviceNotificationsData.loading ? (React.createElement(Spinner, null)) : (React.createElement("div", null,
        React.createElement(PageLayout, { title: "Brahmos" },
            React.createElement(GrayText, null, "Only Micros platform onboarded services are supported by this Framework"),
            React.createElement(Separator, null),
            React.createElement(Breadcrumbs, null,
                React.createElement(BreadcrumbsItem, { href: "./", text: "Home" }),
                React.createElement(BreadcrumbsItem, { href: "./notifications", text: "Notifications" })),
            React.createElement(SectionMessage, { appearance: "info" },
                "You have to add",
                " ",
                React.createElement("a", { href: "https://atlassian.slack.com/apps/A01P5QPJS7L-brahmos?settings=1&next_id=0", target: "_blank", rel: "noopener noreferrer" },
                    "Brahmos ",
                    React.createElement(LinkIcon, { size: "small", label: "Link" }),
                    " "),
                " ",
                "slack app to your channel to receive notifications"),
            serviceNotification && serviceNotification.channel.length > 0 ? (React.createElement("div", null, isEditMode ? (React.createElement(NotificationEditForm, { serviceId: serviceId, serviceNotification: serviceNotification, setIsEditMode: setIsEditMode, setServiceNotification: setServiceNotification })) : (React.createElement("div", null,
                React.createElement(NotificationDetailView, { serviceNotification: serviceNotification, setIsEditMode: setIsEditMode, setServiceNotification: setServiceNotification }))))) : (React.createElement("div", null,
                React.createElement(NotificationCreateForm, { serviceId: props.id, setServiceNotification: setServiceNotification }))))));
};
export var WargameNotificationPage = compose(graphql(ServiceNotificationQuery, {
    name: "serviceNotificationsData",
    options: function (_a) {
        var id = _a.id;
        return ({
            query: ServiceNotificationQuery,
            variables: {
                serviceId: id,
                skip: false
            }
        });
    }
}))(WargameNotificationComponent);
